module.exports = __webpack_public_path__ + "static/assets/f432eb017eac0d2a6e468b5cde0ce27d.svg";